// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active-article[data-v-a3b2324e] {\r\n  flex: 1;\n}\n.name-article[data-v-a3b2324e] {\r\n  flex: 3;\n}\n.role-article[data-v-a3b2324e] {\r\n  flex: 3;\n}\n.area-article[data-v-a3b2324e] {\r\n  flex: 3;\n}\r\n", ""]);
// Exports
module.exports = exports;
